import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import HowItWorks from '../components/HowItWorks';
import ValueMatrix from '../components/ValueMatrix';
import Services from '../components/Services';
import WhyUs from '../components/WhyUs';
import Faq from '../components/Faq';
import SecondaryLead from '../components/SecondaryLead';

export default function Home() {
  return (
    <main>
      <Hero />
      <TrustBar />
      <HowItWorks />
      <ValueMatrix />
      <Services />
      <WhyUs />
      <Faq />
      <SecondaryLead />
    </main>
  );
}
